import { j as a } from "../../../node_modules/react/jsx-runtime.js";
import { memo as m } from "react";
import { clsx as d } from "../../../node_modules/clsx/dist/clsx.m.js";
import o from "./LoadingIndicator.module.scss.js";
import c from "../Icon/Icon.js";
const e = ({
  className: r = "",
  size: n = "sm",
  text: s,
  ...i
}) => {
  const t = d(
    o.LoadingIndicator,
    o[n],
    r
  );
  return /* @__PURE__ */ a.jsxs(
    "div",
    {
      className: t,
      ...i,
      children: [
        /* @__PURE__ */ a.jsx(
          c,
          {
            name: "Loader",
            className: o.loader
          }
        ),
        s && /* @__PURE__ */ a.jsx("span", { className: o.text, children: s })
      ]
    }
  );
}, L = m(e);
export {
  L as default
};
//# sourceMappingURL=LoadingIndicator.js.map
